export default function ReportingRoutes(staticTitle) {
    return [
        {
            path: '/pscmservice/contractreporting',
            meta: {
                title: `${staticTitle} - CRF Contract Reporting`
            },
            children: [
                {
                    path: '/pscmservice/contractreporting',
                    name: 'contractreporting',
                    meta: {
                        title: `${staticTitle} - CRF Contract Reporting`
                    },
                    component: () => {
                        return import('@/views/pscm/reporting/List.vue');
                    }
                },
                {
                    path: '/pscmservice/contractreporting/list',
                    name: 'contractreportinglist',
                    meta: {
                        title: `${staticTitle} - CRF Contract Reporting`
                    },
                    component: () => {
                        return import('@/views/pscm/reporting/List.vue');
                    }
                }
            ]
        }
    ];
}
